import { useQuery } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router';
import { CalendarClockIcon, ClipboardListIcon } from 'lucide-react';
import { EmptyState, PageHeader } from '@/components/page';
import { Skeleton } from '@/components/ui/skeleton';
import { uk } from '@/i18n/uk';
import { trpc } from '@/lib/trpc';

export const Route = createFileRoute('/_app/me/')({
  component: CabinetHome,
});

/** Головна кабінету працівника: посади і швидкі дії. */
function CabinetHome() {
  const t = uk.cabinet;
  const me = useQuery(trpc.me.employee.queryOptions());
  if (me.isPending) return <Skeleton className="h-48" />;
  if (!me.data) return <EmptyState title={t.noEmployee} />;
  return (
    <>
      <PageHeader title={me.data.name} description={t.title} />
      <section className="mb-6 space-y-2">
        <h2 className="text-sm font-medium text-muted-foreground">{t.positions}</h2>
        <ul className="space-y-1">
          {me.data.assignments.map((a) => (
            <li key={a.id} className="rounded-md border px-3 py-2 text-sm">
              <span className="font-medium">{a.positionTitle}</span> · {a.projectCode} · {a.fte} FTE
            </li>
          ))}
        </ul>
      </section>
      <div className="grid gap-3 sm:grid-cols-2">
        <Link
          to="/me/timesheet"
          className="flex items-center gap-3 rounded-lg border p-4 hover:bg-muted/50"
        >
          <CalendarClockIcon className="size-6 text-primary" />
          <span className="font-medium">{t.timesheet}</span>
        </Link>
        <Link
          to="/me/reports"
          className="flex items-center gap-3 rounded-lg border p-4 hover:bg-muted/50"
        >
          <ClipboardListIcon className="size-6 text-primary" />
          <span className="font-medium">{t.reports}</span>
        </Link>
      </div>
    </>
  );
}
